import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, CheckIcon } from 'lucide-react';
import { Section, Heading, Eyebrow } from '../Section';
import { SectionCTA } from '../SectionCTA';
import { tomos, IMAGES } from '../../data/content';
export function Tomos() {
  return <Section tone="white" id="contenido" data-id="element-328" data-mp="cvwc45j5783r">
      <Eyebrow data-id="element-329" data-mp="cuupd3srkx67">Esto es todo lo que recibirás hoy</Eyebrow>
      <Heading data-id="element-330" data-mp="3be1m6x6i9nmt">
        El Sistema de Decisión Clínica <span className="italic text-brand" data-id="element-331" data-mp="3bfcnmqchajar">para Diabetes</span>
      </Heading>

      <div className="mx-auto mt-6 max-w-xl space-y-3 text-center text-[15px] leading-relaxed text-navy/75 sm:text-[17px]" data-id="element-332" data-mp="3gdxnuprqd2z7">
        <p className="font-serif text-lg font-bold italic text-navy sm:text-xl" data-id="element-333" data-mp="3lao4be7g60l5">
          No estás comprando un manual.
        </p>
        <p data-id="element-334" data-mp="10lqlue860gjs">
          Estás incorporando a tu consulta un sistema diseñado para ayudarte a tomar mejores
          decisiones clínicas, reducir la incertidumbre y ahorrar tiempo en cada paciente.
        </p>
      </div>

      <img src={IMAGES.bundle} alt="Los 6 tomos del Sistema de Decisión Clínica para Diabetes" className="mx-auto mt-6 w-full max-w-md" loading="lazy" data-id="element-335" data-mp="1htab7zro08ug" />

      <p className="mx-auto mt-4 max-w-lg text-center text-[14.5px] font-semibold leading-relaxed text-navy/70" data-id="element-336" data-mp="18ru4q33z0qvi">
        Cada tomo resuelve una etapa específica del manejo de la diabetes para que siempre sepas cuál
        es el siguiente paso.
      </p>

      <div className="mt-9 space-y-4" data-id="element-337" data-mp="yv7jvebn9zth">
        {tomos.map((tomo, i) => <motion.article key={tomo.number} initial={{
        opacity: 0,
        y: 18
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.45,
        ease: 'easeOut',
        delay: i % 2 * 0.05
      }} className="overflow-hidden rounded-3xl border border-navy/10 bg-cream" data-id="element-338" data-mp="u2edyn4fwlft" data-mpi={i}>
            <div className="flex items-center gap-2.5 bg-navy px-4 py-2.5" data-id="element-339" data-mp="b422guq22zh2">
              <BookOpenIcon className="h-4 w-4 shrink-0 text-brand-light" aria-hidden="true" data-id="element-340" data-mp="1gpuhqxmehjl" />
              <span className="text-[11.5px] font-extrabold uppercase tracking-[0.2em] text-brand-light" data-id="element-341" data-mp="6fsyr95s0jqi">
                Tomo {tomo.number}
              </span>
            </div>

            <div className="p-4 sm:p-5" data-id="element-342" data-mp="3nq0troctd1pm">
              <h3 className="text-balance font-serif text-[21px] font-extrabold leading-tight text-navy sm:text-[26px]" data-id="element-343" data-mp="3smhhihg3pe26">
                {tomo.title}
              </h3>
              <p className="mt-2.5 text-[14px] leading-relaxed text-navy/70 sm:text-[15px]" data-id="element-344" data-mp="k9jyxqxmar9k">
                {tomo.promise}
              </p>

              <p className="mt-4 text-[11.5px] font-extrabold uppercase tracking-[0.14em] text-brand" data-id="element-345" data-mp="agcv4aiizjbl">
                {tomo.intro}
              </p>
              <ul className="mt-2.5 space-y-2" data-id="element-346" data-mp="fe4m92bcj1eq">
                {tomo.bullets.map(bullet => <li key={bullet} className="flex items-start gap-2.5" data-id="element-347" data-mp="1348mczpbsj0z">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-good" aria-hidden="true" data-id="element-348" data-mp="17ycyryhd1j9g" />
                    <span className="text-[14px] font-semibold leading-snug text-navy sm:text-[15px]" data-id="element-349" data-mp="2slm9saiz8b9l">
                      {bullet}
                    </span>
                  </li>)}
              </ul>
            </div>
          </motion.article>)}
      </div>

      <SectionCTA promise="Seis etapas del manejo de la diabetes, resueltas de principio a fin." label="Quiero los 6 tomos ahora" data-id="element-350" data-mp="2xf8g7kyjriwy" />
    </Section>;
}